// extracted by mini-css-extract-plugin
module.exports = {"root":"OVPnNFgKWew9ESFVUlXC","error":"I5G8Mb8qXakX2tLNMnXl"};